import React from "react";
import { Col, Row } from "antd";
import { useTranslation } from "react-i18next";
import AdnPageTitle from "../common/adnPageTitle/AdnPageTitle";
import AdnTable from "../common/adnTable/AdnTable";
import AdnCard from "../common/adnCard/AdnCard";
import AdnDropdown from "../common/adnDropdown/AdnDropdown";
import AdnAddButton from "../common/adnAddButton/AdnAddButton";
import AdnAutoComplete from "../common/adnAutoComplete/AdnAutoComplete";
import { CriticalSituationStatus } from "../common/GeneralConfigurations";

const CriticalSituationListForm = ({
  title,
  criticalSituations,
  loading,
  columns,
  currentPage,
  totalRecords,
  pageSize,
  handleTableOrderByChanges,
  handleChangePage,
  statusOptions = [],
  statusHandleChange,
  managerOptions = [],
  managerHandleChange,
  handleAddCriticalSituation,
  handleSearchEmployee,
  handleSelectEmployee,
  handleClearEmployee,
  employeesList,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <AdnPageTitle title={title} />
      <AdnCard loading={loading}>
        <Row className="consultants-list-actions" gutter={16}>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 24 }}
            lg={{ span: 24 }}
            xl={{ span: 3 }}
            xxl={{ span: 9 }}
          >
            <AdnAddButton
              handleClick={handleAddCriticalSituation}
              name={t("criticalSituationListForm.buttons.add")}
            />
          </Col>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 24 }}
            lg={{ span: 24 }}
            xl={{ span: 9 }}
            xxl={{ span: 9 }}
            className="filter-item"
          >
            <AdnAutoComplete
              valueId="name"
              placeholder={t(
                "criticalSituationListForm.placeholders.selectConsultant"
              )}
              handleSearch={handleSearchEmployee}
              handleSelect={handleSelectEmployee}
              handleClear={handleClearEmployee}
              resultList={employeesList}
              allowClear={true}
            />
          </Col>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 12 }}
            xl={{ span: 6 }}
            xxl={{ span: 3 }}
            className="filter-item"
          >
            <AdnDropdown
              name="managerId"
              placeholder={t(
                "criticalSituationListForm.placeholders.selectManager"
              )}
              options={managerOptions}
              handleChange={managerHandleChange}
              valueIsId={true}
              allowClear={true}
            />
          </Col>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 12 }}
            xl={{ span: 6 }}
            xxl={{ span: 3 }}
            className="filter-item"
          >
            <AdnDropdown
              handleChange={statusHandleChange}
              placeholder={t(
                "criticalSituationListForm.placeholders.selectStatus"
              )}
              allowClear={true}
              defaultValue={CriticalSituationStatus.FollowingUp}
              options={statusOptions}
            />
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <AdnTable
              columns={columns}
              data={criticalSituations}
              currentPage={currentPage}
              totalRecords={totalRecords}
              pageSize={pageSize}
              handleChange={handleTableOrderByChanges}
              handleChangePage={handleChangePage}
            />
          </Col>
        </Row>
      </AdnCard>
    </>
  );
};

export default CriticalSituationListForm;
